import { SET_ACTION_TYPE_VALUE } from "../action";

export function setActionType(name, value) {
  return (dispatch) => {
    dispatch({ type: SET_ACTION_TYPE_VALUE, payload: { name, value } });
  };
}
